export default function reducer(
  state = {
    status: "",
    error: null,
    zones: {},
    tags: {},
    tagsList: [],
    alert: {
      section: {
        id: 0,
        valid: false,
        invalid: false,
        message: ''
      },
      color: {
        id: 0,
        valid: false,
        invalid: false,
        message: ''
      },
      telegram: {
        id: 0,
        valid: false,
        invalid: false,
        message: ''
      },
      _create: {
        id: '',
        valid: false,
        invalid: false,
        message: ''
      },
      _point: {
        id: '',
        zone: '',
        valid: false,
        invalid: false,
        message: ''
      }
    }
  },
  action
) {
  let data
  switch (action.type) {
    case "CLEAR_STORE":
      state = defaultState()
      break;
    case "ZONES_INFO_INIT":
      data = action.payload.data
      state = {
        ...state,
        error: null,
        status: "ZONES_INFO_INIT",
        zones: { ...state.zones, ...data }
      }
      break;
    case "ZONES_LIST_FULFILLED":
      state = updateZoneList(state, action.payload.data)
      break;
    case "ZONES_UPDATE_ALERT":
      state = updateZoneAlert(state, action.payload)
      break;
    default:
      return state;
  }
  return state;
}

const updateZoneList = (state, zonelist) => {
  let { zones, tags, tagsList, ..._state } = state
  zones = {}
  tagsList = []
  zonelist.forEach(zone => {
    const { checkpoints, ..._zone } = zone
    let __zone = {
      ..._zone,
      byid: {},
      list: []
    }
    checkpoints.forEach(point => {
      __zone.byid[point.serialNumber] = point
      __zone.list.push(point.serialNumber)
    })

    zones[zone.section] = zone
    tags[zone.section] = __zone
    tagsList.push(zone.section)
  });

  _state = {
    ..._state,
    zones: zones,
    tags: tags,
    tagsList: tagsList
  }
  return _state
}

const updateZoneAlert = (state, payload) => {
  //console.log('updateZoneAlert > state :', state)
  //console.log('updateZoneAlert > payload :', payload.type)
  //console.log('updateZoneAlert > payload :', payload.status)
  let { alert, ..._state } = state
  let { [payload.type]: attr, ..._alert } = alert
  let _attr = {
    ...attr,
    ...payload.status
  }
  _alert = {
    ..._alert,
    [payload.type]: _attr
  }
  _state = {
    ..._state,
    alert: _alert
  }
  return _state
}

function defaultState() {
  return {
    status: "",
    error: null,
    zones: {},
    tags: {},
    tagsList: [],
    alert: {
      section: {
        id: 0,
        valid: false,
        invalid: false,
        message: ''
      },
      color: {
        id: 0,
        valid: false,
        invalid: false,
        message: ''
      },
      telegram: {
        id: 0,
        valid: false,
        invalid: false,
        message: ''
      },
      _create: {
        id: '',
        valid: false,
        invalid: false,
        message: ''
      },
      _point: {
        id: '',
        zone: '',
        valid: false,
        invalid: false,
        message: ''
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/_zones.js